/**
 * Shared TB Blood questionnaire (5 risk + 7 symptom + patient signature/comments).
 * Used by TB Blood Draw, TB Skin Test, and Mobile Health TB Assessment flows.
 */

export const tbRiskQuestions = [
  {
    label:
      "1. Were you born outside the USA in one of the following parts of the world: Africa, Asia, Central America, South America, or Eastern Europe?",
    name: "tb_risk_born_outside_usa",
    id: "tb_risk_born_outside_usa",
  },
  {
    label:
      "2. Have you traveled outside the USA and lived for more than one month in one of the following parts of the world: Africa, Asia, Central America, South America, or Eastern Europe?",
    name: "tb_risk_traveled_outside_usa",
    id: "tb_risk_traveled_outside_usa",
  },
  {
    label:
      "3. Do you have a compromised immune system, such as from any of the following conditions: HIV/AIDS, organ or bone marrow transplantation, diabetes, immunosuppressive medicines (e.g., prednisone, Remicade), leukemia, lymphoma, cancer of the head or neck, gastrectomy or jejunal bypass, end-stage renal disease (on dialysis), or silicosis?",
    name: "tb_risk_compromised_immune_system",
    id: "tb_risk_compromised_immune_system",
  },
  {
    label:
      "4. Have you ever done one of the following: used crack cocaine, injected illegal drugs, worked or resided in jail or prison, worked or resided at a homeless shelter, or worked as a healthcare worker in direct contact with patients?",
    name: "tb_risk_high_risk_activities",
    id: "tb_risk_high_risk_activities",
  },
  {
    label: "5. Have you ever been exposed to anyone with infectious tuberculosis?",
    name: "tb_risk_exposed_to_tb",
    id: "tb_risk_exposed_to_tb",
  },
];

export const tbSymptomQuestions = [
  {
    label: "1. Unexplained cough lasting more than 3 weeks?",
    name: "tb_symptom_cough_3_weeks",
    id: "tb_symptom_cough_3_weeks",
  },
  {
    label: "2. Unexplained fever lasting more than 3 weeks?",
    name: "tb_symptom_fever_3_weeks",
    id: "tb_symptom_fever_3_weeks",
  },
  {
    label:
      "3. Night sweats (sweating that leaves the bedclothes and sheets wet)?",
    name: "tb_symptom_night_sweats",
    id: "tb_symptom_night_sweats",
  },
  {
    label: "4. Shortness of breath?",
    name: "tb_symptom_shortness_breath",
    id: "tb_symptom_shortness_breath",
  },
  {
    label: "5. Chest pain?",
    name: "tb_symptom_chest_pain",
    id: "tb_symptom_chest_pain",
  },
  {
    label: "6. Unintentional weight loss?",
    name: "tb_symptom_weight_loss",
    id: "tb_symptom_weight_loss",
  },
  {
    label: "7. Unexplained fatigue (very tired for no reason)?",
    name: "tb_symptom_fatigue",
    id: "tb_symptom_fatigue",
  },
];

const TB_YES_NO_OPTIONS = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

/** Default form values for TB Blood–aligned questionnaire fields (0/1 + strings). */
export const tbQuestionnaireFormDefaults = {
  ...tbRiskQuestions.reduce((acc, itm) => {
    acc[itm.name] = 0;
    return acc;
  }, {}),
  ...tbSymptomQuestions.reduce((acc, itm) => {
    acc[itm.name] = 0;
    return acc;
  }, {}),
  tb_comments: "",
  tb_patient_signature: "",
};

/**
 * Card sections matching TB Blood "History" questionnaire (risk, symptom, signature).
 * For embedding in Mobile Health patient tabs or other multi-section charts.
 */
export function getTbBloodPatientQuestionnaireCardSections() {
  return [
    {
      label: "Tuberculosis Risk Questionnaire",
      hideHeader: true,
      cardBodyClassName: "p-0",
      fields: [
        {
          type: "NewYesOrNoFields",
          label: "Tuberculosis Risk Questionnaire",
          col: "col-12",
          options: TB_YES_NO_OPTIONS,
          defaultValues: tbRiskQuestions.reduce((acc, itm) => {
            acc[itm.name] = 0;
            return acc;
          }, {}),
          list: tbRiskQuestions,
        },
      ],
    },
    {
      label: "Tuberculosis Symptom Questionnaire",
      hideHeader: true,
      cardBodyClassName: "p-0",
      fields: [
        {
          type: "NewYesOrNoFields",
          label: "Tuberculosis Symptom Questionnaire ",
          subLabel: "Do you currently have any of the following symptoms?",
          sublabelStyle: "text-left text-black text-md fw-bold opacity-100",
          col: "col-12",
          options: TB_YES_NO_OPTIONS,
          defaultValues: tbSymptomQuestions.reduce((acc, itm) => {
            acc[itm.name] = 0;
            return acc;
          }, {}),
          list: tbSymptomQuestions,
        },
      ],
    },
    {
      label: "Patient Signature & Comments",
      labelStyle: "fw-semibold pl-2",
      col: "col-12",
      fields: [
        {
          label: "Comments",
          type: "TextArea",
          name: "tb_comments",
          id: "tb_comments",
          col: "col-md-6 col-12 border-0",
          layout: "stacked",
          labelStyle: { paddingLeft: "0.75rem" },
          style: { minHeight: "150px", resize: "vertical" },
          rows: 5,
          placeholder: "Content",
        },
        {
          label: "Signature",
          type: "NewSignature",
          isLabel: false,
          col: "col-md-6 col-12 border-0",
          name: "tb_patient_signature",
          id: "tb_patient_signature",
        },
      ],
    },
  ];
}
